import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { Observable } from 'rxjs';

import { TechnicalAlert } from './technical-alert';
import { TechnicalAlertsService } from './technical-alerts.service';

@Component({
    selector: 'app-technical-alerts',
    templateUrl: './technical-alerts.component.html',
    styleUrls: ['./technical-alerts.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class TechnicalAlertsComponent implements OnInit {
	public technicalAlerts$: Observable<Array<TechnicalAlert>>;

	constructor(public technicalAlertService: TechnicalAlertsService) { }

	public ngOnInit(): void {
		this.technicalAlerts$ = this.technicalAlertService.getTechnicalAlerts(
			'PRELOGIN',
		);
	}
}
